<template>
  <div class="vehicle-scoring">
    <div class="vehicle-scoring__score vehicle-scoring__score--positive">{{ vehicleScoreValue }}</div>
    <div class="vehicle-scoring__text">{{ vehicleScoreText }}</div>
    <div class="vehicle-scoring__score">{{ vehicleAPRValue }}</div>
    <div class="vehicle-scoring__text vehicle-scoring__text--last">{{ vehicleAPRText }}</div>
  </div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

@Component
export default class VehicleScoringComponent extends Vue {
@Prop({ default: '8.9' })
public vehicleScoreValue!: string;

@Prop({ default: 'Great' })
public vehicleScoreText!: string;

@Prop({ default: '4.9' })
public vehicleAPRValue!: string;

@Prop({ default: '% APR Available*' })
public vehicleAPRText!: string;
}
</script>
